import { Session } from "@supabase/supabase-js";
import {
  FC,
  ReactNode,
  createContext,
  useContext,
  useEffect,
  useState,
} from "react";
import { supabaseClient } from "src/lib/supabase/supabaseClient";
import * as Sentry from "@sentry/react";

type SessionContextType = {
  session: Session | null;
  loading: boolean;
};
// sets the context to null by default
const SessionContext = createContext<SessionContextType>({
  session: null,
  loading: true,
});

//Provider component to wrap the app
export const SessionContextProvider: FC<{
  children: ReactNode;
}> = ({ children }) => {
  const [loading, setLoading] = useState<boolean>(true);
  const [session, setSession] = useState<Session | null>(null);

  useEffect(() => {
    // Get current session from supabase
    supabaseClient.auth.getSession().then(({ data: { session } }) => {
      setSession(session);
      Sentry.setUser({
        id: session?.user.id,
      });
      setLoading(false);
    });

    // subscribe to auth state changes and update the session state
    const {
      data: { subscription },
    } = supabaseClient.auth.onAuthStateChange((_event, session) => {
      setSession(session);
      Sentry.setUser({
        id: session?.user.id,
      });
    });
    // clean up subscriptions on component unmount
    return () => subscription.unsubscribe();
  }, []);

  return (
    <SessionContext.Provider value={{ session, loading }}>
      {children}
    </SessionContext.Provider>
  );
};

// Custom hook for any access to the context
export const useSession = () => useContext(SessionContext);
